import type { Translate } from '@shared/hooks/locale';
import { Currencies, type Currency } from '@shared/LocaleContext';

type SubscriptionItems = {
  data?: Array<{
    price?: {
      currency?: string;
    };
  }>;
} | null;

export type SubscriptionStatus =
  | 'active'
  | 'trialing'
  | 'past_due'
  | 'canceled'
  | 'unpaid'
  | 'incomplete'
  | 'incomplete_expired';

export const getSubscriptionCurrency = (subscription: {
  items: SubscriptionItems;
}): Currency => {
  const currency =
    subscription.items?.data?.[0]?.price?.currency?.toUpperCase();
  return (Currencies as readonly string[]).includes(currency ?? '')
    ? (currency as Currency)
    : 'EUR';
};

export const getSubscriptionStatusLabel = (
  status: SubscriptionStatus | (string & {}),
  t: Translate,
) => {
  const labels: Record<string, string> = {
    active: t('Active'),
    trialing: t('Trialing'),
    past_due: t('Past due'),
    canceled: t('Canceled'),
    unpaid: t('Unpaid'),
    incomplete: t('Incomplete'),
    incomplete_expired: t('Expired'),
  };
  return labels[status] ?? status;
};

type StatusColor = 'success' | 'info' | 'warning' | 'error' | 'default';

export const getSubscriptionStatusColor = (status: string): StatusColor => {
  switch (status) {
    case 'active':
      return 'success';
    case 'trialing':
      return 'info';
    case 'past_due':
      return 'error';
    case 'unpaid':
    case 'incomplete':
      return 'warning';
    case 'canceled':
    case 'incomplete_expired':
      return 'default';
    default:
      return 'default';
  }
};
